<template>
  <div>
    <div class="flex space-x-2 text-xs">
      <span class="global-button-xs cursor-pointer" @click="riskStatus = 1"
        >Yatırımı Onayla</span
      >
      <span class="global-button-xs cursor-pointer" @click="riskStatus = 2"
        >Yatırımı İptal Et</span
      >
      <span class="global-button-xs cursor-pointer" @click="riskStatus = 3"
        >Yatırımı Reddet</span
      >
    </div>
    <form
      v-if="riskStatus == 1"
      class="text-xs flex space-x-2 items-center"
      @submit.prevent="riskOk()"
    >
      <div>
        <label>Platforma İşlenen Tutar </label>
        <div class="flex items-center space-x-2">
          <input
            type="text"
            class="uk-input w-full"
            v-model="form.amount_platform"
          />

          <select
            v-model="form.platform_currency_id"
            class="uk-select"
            style="width:100px"
          >
            <option
              v-for="template in $root.cache.getOptions[148]"
              :value="template.value"
              :key="template.value"
              >{{ template.label }}
            </option>
          </select>
        </div>
      </div>
      <div style="display:none; /*  trello BfvCtIvk */">
        <label>Bankaya İşlenen Tutar</label>
        <div class="flex items-center space-x-2">
          <input
            type="text"
            class="uk-input w-full"
            v-model="form.amount_bank"
          />

          <select
            v-model="form.bank_currency_id"
            class="uk-select"
            style="width:100px"
          >
            <option
              v-for="template in $root.cache.getOptions[148]"
              :value="template.value"
              :key="template.value"
              >{{ template.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="self-end">
        <SaveButton title="Kaydet" />
      </div>
    </form>

    <form
      v-if="riskStatus >= 2"
      class="text-xs flex space-x-2 items-center"
      @submit.prevent="riskCanceled(riskStatus)"
    >
      <div>
        <label>Sebep </label>
        <input type="text" class="uk-input w-full" v-model="form.comment" />
      </div>
      <div class="self-end">
        <SaveButton title="Kaydet" />
      </div>
    </form>
  </div>
</template>
<script>
import http from "../../../services/http";
import EventBus from "../../Ui/EventBus";
import SaveButton from "../../Ui/SaveButton.vue";
export default {
  props: ["id"],
  data() {
    return {
      riskStatus: null,
      form: {},
    };
  },
  methods: {
    riskOk() {
      http.transaction
        .riskOk(this.id, this.form)
        .then(() => {
          EventBus.$emit("transactionReload", true);
        })
        .catch((msg) => {
          this.$root.errorMessage(msg.response.data);
        });
    },

    riskCanceled(type) {
      if (type == 3) {
        http.transaction
          .riskBlocked(this.id, this.form)
          .then(() => {
            EventBus.$emit("transactionReload", true);
          })
          .catch((msg) => {
            this.$root.errorMessage(msg.response.data);
          });
      } else {
        http.transaction
          .riskCanceled(this.id, this.form)
          .then(() => {
            EventBus.$emit("transactionReload", true);
          })
          .catch((msg) => {
            this.$root.errorMessage(msg.response.data);
          });
      }
    },
  },
  components: { SaveButton },
};
</script>
